import React from 'react'
import { LightBulbIcon } from 'images'
import LoaderSpinner from 'components/Shared/Loader/LoaderSpinner'
import { useTranslation } from 'react-i18next'

const GenerateButton = ({ onClick, disabled = false, loading = false, creditCost = null }) => {
  const { i18n, t } = useTranslation()
  const label = creditCost > 0
    ? t('Recommendations.campaign.setup.coCreatePanel.credits.generateWithCost', {
      cost: Number(creditCost).toLocaleString(i18n?.language ?? 'en'),
    })
    : t('Recommendations.campaign.setup.coCreatePanel.generate')

  return (
    <button type="button" className={`generate-button ${loading ? 'generating' : ''} ${disabled ? 'disabled' : ''}`} onClick={onClick} disabled={disabled} loading={loading}>
      <span className="icon">
        {loading ? 
          <LoaderSpinner
            className="bt-loading-spinner"
            showText={false}
            size="mini"
            portalBackground={false}
          />
          : 
          <LightBulbIcon width={16} height={16} />}
      </span>

      <span className="text">
        {loading ? t('Recommendations.campaign.setup.coCreatePanel.generating') : label}
      </span>
    </button>
  )
}

export default GenerateButton
